export const SIGNALR_CONNECTION = {
    JOIN_REALTIME_VIEWS: 'JoinRoom',
    JOIN_NOTIFICATION: 'JoinProjectRoom',
    JOIN_CHAT: 'JoinChatRoom',
    JOIN_COMMENTS: 'JoinCommentRoom',
  }